var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { hideMenuProvider } from '../../utilities/picker.tools';
import styles from '../sds-date-picker.lit.scss';
import '../shared/calendar/sds-calendar.lit';
import { yearHoverStateMapper, yearRangeMapper } from '../shared/mapper-utils';
import { formatYear } from './year-picker-calculations';
import { translate } from '../../utilities/translate';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `sds-year-range` is a web component designed for selecting a range of years.
 * It allows users to easily choose a start and end year for various applications,
 * such as event planning, reporting, or filtering data over a specific time range.
 *
 * The component features customizable attributes, including options for placeholders,
 * currently selected years, hints, and error handling.
 *
 * ### Attributes
 * - `placeholder`: The placeholder text for the input fields. Defaults to `'sds.year_picker_range.placeholder'`.
 * - `start-year`: The starting year of the selected range. Reflects the selected year as a number or undefined.
 * - `end-year`: The ending year of the selected range. Reflects the selected year as a number or undefined.
 * - `current-year`: Represents the current year, reflecting the current context for year selection.
 * - `hint`: A hint to provide context for the selection.
 * - `disabled`: A boolean indicating if the range picker is disabled. Defaults to `false`.
 * - `invalid`: A boolean indicating if the selection is invalid. Defaults to `false`.
 * - `error-message`: The error message to display if validation fails.
 *
 * @tag sds-year-range
 */
let SdsYearRange = (() => {
    var _SdsYearRange_placeholder_accessor_storage, _SdsYearRange_startYear_accessor_storage, _SdsYearRange_endYear_accessor_storage, _SdsYearRange_currentYear_accessor_storage, _SdsYearRange_hint_accessor_storage, _SdsYearRange_disabled_accessor_storage, _SdsYearRange_invalid_accessor_storage, _SdsYearRange_errorMessage_accessor_storage, _SdsYearRange__contextMenu_accessor_storage, _SdsYearRange__inputDate_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-year-range')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _startYear_decorators;
    let _startYear_initializers = [];
    let _startYear_extraInitializers = [];
    let _endYear_decorators;
    let _endYear_initializers = [];
    let _endYear_extraInitializers = [];
    let _currentYear_decorators;
    let _currentYear_initializers = [];
    let _currentYear_extraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let __contextMenu_decorators;
    let __contextMenu_initializers = [];
    let __contextMenu_extraInitializers = [];
    let __inputDate_decorators;
    let __inputDate_initializers = [];
    let __inputDate_extraInitializers = [];
    var SdsYearRange = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsYearRange_placeholder_accessor_storage.set(this, __runInitializers(this, _placeholder_initializers, 'sds.year_picker_range.placeholder'));
            _SdsYearRange_startYear_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _startYear_initializers, void 0)));
            _SdsYearRange_endYear_accessor_storage.set(this, (__runInitializers(this, _startYear_extraInitializers), __runInitializers(this, _endYear_initializers, void 0)));
            _SdsYearRange_currentYear_accessor_storage.set(this, (__runInitializers(this, _endYear_extraInitializers), __runInitializers(this, _currentYear_initializers, void 0)));
            _SdsYearRange_hint_accessor_storage.set(this, (__runInitializers(this, _currentYear_extraInitializers), __runInitializers(this, _hint_initializers, '')));
            _SdsYearRange_disabled_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsYearRange_invalid_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsYearRange_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            _SdsYearRange__contextMenu_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, __contextMenu_initializers, void 0)));
            _SdsYearRange__inputDate_accessor_storage.set(this, (__runInitializers(this, __contextMenu_extraInitializers), __runInitializers(this, __inputDate_initializers, void 0)));
            this._sdsInnerYearPicker = __runInitializers(this, __inputDate_extraInitializers);
            this.hideMenu = hideMenuProvider(this);
            this.mouseOutHandler = () => {
                if (this.endYear === undefined) {
                    this.configureYearStateMapper();
                }
            };
            this.handleCleared = () => {
                var _a;
                this._inputDate.focused = Boolean((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened);
                this.updateValue();
                this.updatePageIndex();
            };
            this.handleHover = (event) => {
                if (this.startYear !== undefined &&
                    this.endYear === undefined &&
                    event.detail.hoveredYear !== undefined) {
                    this.updateStatesOnHover(this.startYear, event.detail.hoveredYear);
                }
                else if (event.detail.hoveredYear === undefined) {
                    this.configureYearStateMapper();
                }
            };
            this.showContextMenu = () => {
                var _a, _b;
                if (!((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened)) {
                    this.resetPage();
                    this._inputDate.focused = true;
                    const trigger = this._inputDate.getInput();
                    (_b = this._contextMenu) === null || _b === void 0 ? void 0 : _b.show(trigger);
                    this.configureYearStateMapper();
                }
            };
            this.handleYearPicked = (event) => {
                this.updateValue(event.detail.selectedYear);
            };
        }
        /**
         * Sets the placeholder text for the year range input fields, providing a hint to users when no year is selected.
         * This attribute helps guide users to understand the expected input or purpose of the year selection.
         *
         * This placeholder text enhances accessibility and user experience by indicating
         * what the user is expected to select.
         *
         * @attr {string} placeholder - Placeholder text for the year range input fields.
         */
        get placeholder() { return __classPrivateFieldGet(this, _SdsYearRange_placeholder_accessor_storage, "f"); }
        set placeholder(value) { __classPrivateFieldSet(this, _SdsYearRange_placeholder_accessor_storage, value, "f"); }
        /**
         * Specifies the starting year of the selected range.
         * This attribute allows users to define the beginning of the year range they wish to select.
         *
         * Setting this attribute updates the internal state of the component, ensuring that
         * the selection reflects the correct start year.
         *
         * @attr {number} start-year - The starting year of the selected range.
         */
        get startYear() { return __classPrivateFieldGet(this, _SdsYearRange_startYear_accessor_storage, "f"); }
        set startYear(value) { __classPrivateFieldSet(this, _SdsYearRange_startYear_accessor_storage, value, "f"); }
        /**
         * Specifies the ending year of the selected range.
         * This attribute allows users to define the end of the year range they wish to select.
         *
         * Setting this attribute updates the internal state of the component, ensuring that
         * the selection reflects the correct end year.
         *
         * @attr {number} end-year - The ending year of the selected range.
         */
        get endYear() { return __classPrivateFieldGet(this, _SdsYearRange_endYear_accessor_storage, "f"); }
        set endYear(value) { __classPrivateFieldSet(this, _SdsYearRange_endYear_accessor_storage, value, "f"); }
        /**
         * Represents the current year in the context of the year range selection.
         * This attribute provides a reference point for users when making their selection.
         *
         * @attr {number} current-year - The current year for the selection context.
         */
        get currentYear() { return __classPrivateFieldGet(this, _SdsYearRange_currentYear_accessor_storage, "f"); }
        set currentYear(value) { __classPrivateFieldSet(this, _SdsYearRange_currentYear_accessor_storage, value, "f"); }
        /**
         * Hint for this year range.
         * This attribute provides additional information or guidance to the user regarding the year range selection.
         *
         * @attr {string} hint - A hint to assist users in making their selection.
         */
        get hint() { return __classPrivateFieldGet(this, _SdsYearRange_hint_accessor_storage, "f"); }
        set hint(value) { __classPrivateFieldSet(this, _SdsYearRange_hint_accessor_storage, value, "f"); }
        /**
         * True if this year range is disabled.
         * When set to true, the user cannot interact with the year range picker.
         *
         * @attr {boolean} disabled - Indicates if the year range picker is disabled.
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsYearRange_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsYearRange_disabled_accessor_storage, value, "f"); }
        /**
         * True if this year range is invalid.
         * This attribute indicates that the current selection does not meet the validation criteria.
         *
         * @attr {boolean} invalid - Indicates if the selection is invalid.
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsYearRange_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsYearRange_invalid_accessor_storage, value, "f"); }
        /**
         * The error message of this year range, in case there is a validation error.
         * This message will be displayed to inform the user of any issues with their selection.
         *
         * @attr {string} error-message - The error message to display if validation fails.
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsYearRange_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsYearRange_errorMessage_accessor_storage, value, "f"); }
        get _contextMenu() { return __classPrivateFieldGet(this, _SdsYearRange__contextMenu_accessor_storage, "f"); }
        set _contextMenu(value) { __classPrivateFieldSet(this, _SdsYearRange__contextMenu_accessor_storage, value, "f"); }
        get _inputDate() { return __classPrivateFieldGet(this, _SdsYearRange__inputDate_accessor_storage, "f"); }
        set _inputDate(value) { __classPrivateFieldSet(this, _SdsYearRange__inputDate_accessor_storage, value, "f"); }
        render() {
            var _a;
            return html `
            <sds-input-date
                id="input-date"
                placeholder="${translate(this.placeholder)}"
                readonly
                ?disabled="${this.disabled}"
                hint="${this.hint}"
                error-message="${this.errorMessage}"
                ?invalid="${this.invalid}"
                @click="${this.showContextMenu}"
                @sds.input-date.cleared="${this.handleCleared}"
            ></sds-input-date>
            <sds-context-menu id="context-menu">
                <sds-inner-year-picker
                    id="sds-inner-year-picker"
                    tabindex="0"
                    @mouseout="${this.mouseOutHandler}"
                    current-year="${(_a = this.currentYear) !== null && _a !== void 0 ? _a : new Date().getFullYear()}"
                    @sds.inner-year-picker.changed="${this.handleYearPicked}"
                    @sds.inner-year-picker.hovered="${this.handleHover}"
                >
                </sds-inner-year-picker>
            </sds-context-menu>
        `;
        }
        connectedCallback() {
            super.connectedCallback();
            document.addEventListener('mouseup', this.hideMenu);
        }
        disconnectedCallback() {
            document.removeEventListener('mouseup', this.hideMenu);
            this.hideContextMenu();
            super.disconnectedCallback();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        async firstUpdated() {
            this.initCmContentContainer();
            await this.updateComplete;
            this.updatePageIndex();
        }
        willUpdate(_changedProperties) {
            var _a;
            if (_changedProperties.has('startYear') || _changedProperties.has('endYear')) {
                this.configureYearStateMapper();
            }
            if (_changedProperties.has('endYear') && this.endYear !== undefined) {
                this.hideContextMenu();
            }
            // Reset page index when both years are cleared
            if ((_changedProperties.has('startYear') || _changedProperties.has('endYear')) &&
                this.startYear === undefined &&
                this.endYear === undefined) {
                // Ensure we reset to initial page when both years are cleared
                (_a = this._sdsInnerYearPicker) === null || _a === void 0 ? void 0 : _a.openPageInitialPage();
            }
        }
        updated(_changedProperties) {
            if (_changedProperties.has('startYear') || _changedProperties.has('endYear')) {
                this.updateInput();
            }
        }
        configureYearStateMapper() {
            var _a;
            (_a = this._sdsInnerYearPicker) === null || _a === void 0 ? void 0 : _a.setYearStateMapper(yearRangeMapper(this.startYear, this.endYear));
        }
        initCmContentContainer() {
            var _a;
            const sdsInnerYearPicker = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#sds-inner-year-picker');
            if (sdsInnerYearPicker) {
                this._sdsInnerYearPicker = sdsInnerYearPicker;
            }
        }
        updateStatesOnHover(startYear, hoverYear) {
            var _a;
            (_a = this._sdsInnerYearPicker) === null || _a === void 0 ? void 0 : _a.setYearStateMapper(yearHoverStateMapper(startYear, hoverYear));
        }
        resetPage() {
            this.updatePageIndex();
        }
        updatePageIndex() {
            var _a, _b;
            if (this.startYear === undefined || this.startYear === null) {
                (_a = this._sdsInnerYearPicker) === null || _a === void 0 ? void 0 : _a.openPageInitialPage();
            }
            else {
                (_b = this._sdsInnerYearPicker) === null || _b === void 0 ? void 0 : _b.openPageFor(this.startYear);
            }
        }
        hideContextMenu() {
            var _a;
            if ((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened) {
                this._contextMenu.hide();
            }
        }
        updateValue(year) {
            if (year === undefined) {
                this.startYear = undefined;
                this.endYear = undefined;
                this.dispatchChange();
            }
            else if (this.startYear === undefined || this.endYear !== undefined) {
                this.startYear = year;
                this.endYear = undefined;
            }
            else {
                this.endYear = year;
                if (this.endYear < this.startYear) {
                    [this.startYear, this.endYear] = [this.endYear, this.startYear];
                }
                this.dispatchChange();
            }
        }
        updateInput() {
            const startYearFormatted = formatYear(this.startYear);
            const endYearFormatted = formatYear(this.endYear);
            if (!startYearFormatted && !endYearFormatted) {
                this._inputDate.value = '';
            }
            else {
                let inputValue = startYearFormatted;
                if (endYearFormatted) {
                    inputValue += ' - ' + endYearFormatted;
                }
                this._inputDate.value = inputValue;
            }
        }
        dispatchChange() {
            this.dispatchEvent(new CustomEvent(SdsYearRange.YEAR_RANGE_CHANGE_EVENT, {
                detail: {
                    startYear: this.startYear,
                    endYear: this.endYear,
                },
            }));
        }
    };
    _SdsYearRange_placeholder_accessor_storage = new WeakMap();
    _SdsYearRange_startYear_accessor_storage = new WeakMap();
    _SdsYearRange_endYear_accessor_storage = new WeakMap();
    _SdsYearRange_currentYear_accessor_storage = new WeakMap();
    _SdsYearRange_hint_accessor_storage = new WeakMap();
    _SdsYearRange_disabled_accessor_storage = new WeakMap();
    _SdsYearRange_invalid_accessor_storage = new WeakMap();
    _SdsYearRange_errorMessage_accessor_storage = new WeakMap();
    _SdsYearRange__contextMenu_accessor_storage = new WeakMap();
    _SdsYearRange__inputDate_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsYearRange");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _placeholder_decorators = [property({ type: String })];
        _startYear_decorators = [property({ reflect: true, attribute: 'start-year', type: Number })];
        _endYear_decorators = [property({ reflect: true, attribute: 'end-year', type: Number })];
        _currentYear_decorators = [property({ reflect: true, attribute: 'current-year', type: Number })];
        _hint_decorators = [property({ type: String })];
        _disabled_decorators = [property({ type: Boolean })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        __contextMenu_decorators = [query('#context-menu')];
        __inputDate_decorators = [query('#input-date')];
        __esDecorate(_classThis, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
        __esDecorate(_classThis, null, _startYear_decorators, { kind: "accessor", name: "startYear", static: false, private: false, access: { has: obj => "startYear" in obj, get: obj => obj.startYear, set: (obj, value) => { obj.startYear = value; } }, metadata: _metadata }, _startYear_initializers, _startYear_extraInitializers);
        __esDecorate(_classThis, null, _endYear_decorators, { kind: "accessor", name: "endYear", static: false, private: false, access: { has: obj => "endYear" in obj, get: obj => obj.endYear, set: (obj, value) => { obj.endYear = value; } }, metadata: _metadata }, _endYear_initializers, _endYear_extraInitializers);
        __esDecorate(_classThis, null, _currentYear_decorators, { kind: "accessor", name: "currentYear", static: false, private: false, access: { has: obj => "currentYear" in obj, get: obj => obj.currentYear, set: (obj, value) => { obj.currentYear = value; } }, metadata: _metadata }, _currentYear_initializers, _currentYear_extraInitializers);
        __esDecorate(_classThis, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, __contextMenu_decorators, { kind: "accessor", name: "_contextMenu", static: false, private: false, access: { has: obj => "_contextMenu" in obj, get: obj => obj._contextMenu, set: (obj, value) => { obj._contextMenu = value; } }, metadata: _metadata }, __contextMenu_initializers, __contextMenu_extraInitializers);
        __esDecorate(_classThis, null, __inputDate_decorators, { kind: "accessor", name: "_inputDate", static: false, private: false, access: { has: obj => "_inputDate" in obj, get: obj => obj._inputDate, set: (obj, value) => { obj._inputDate = value; } }, metadata: _metadata }, __inputDate_initializers, __inputDate_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsYearRange = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.YEAR_RANGE_CHANGE_EVENT = 'sds.year-range.changed';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsYearRange = _classThis;
})();
export { SdsYearRange };
